import React from 'react';
import { useTheme } from './ThemeProvider';

interface MindPolishLogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  withText?: boolean;
  className?: string;
}

const MindPolishLogo: React.FC<MindPolishLogoProps> = ({
  size = 'md',
  withText = true,
  className = '',
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  // Size mappings for the logo container
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-20 h-20',
    xl: 'w-28 h-28',
  };

  // Size mappings for the text
  const textSizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-xl',
    xl: 'text-2xl',
  };

  return (
    <div className={`flex items-center ${className}`}>
      <div className={`${sizeClasses[size]} relative flex items-center justify-center`}>
        <svg 
          viewBox="0 0 140 120" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          <defs>
            <radialGradient id="dropletGradient" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor={isDark ? "#D9EFE4" : "#E6F4EA"} />
              <stop offset="100%" stopColor={isDark ? "#A3BFAE" : "#C8E2D3"} />
            </radialGradient>
            <filter id="dropletShadow" x="-10%" y="-10%" width="130%" height="130%">
              <feDropShadow dx="0" dy="3" stdDeviation="5" floodColor={isDark ? "#6B756B" : "#9FBFAE"} floodOpacity="0.3" />
            </filter>
          </defs>
          <path d="
            M60,20
            Q90,45 90,70
            Q90,95 60,100
            Q30,95 30,70
            Q30,45 60,20Z"
            fill="url(#dropletGradient)"
            stroke={isDark ? "#8A948A" : "#A3BFAE"}
            strokeWidth="1.5"
            filter="url(#dropletShadow)"
          />
          <circle cx="60" cy="68" r="18" fill={isDark ? "#8A948A" : "#D9EFE4"} opacity="0.15" />
          <circle cx="52" cy="50" r="5" fill={isDark ? "#D1D6D1" : "#F2F8F5"} opacity="0.25" />
        </svg>
      </div>
      
      {withText && (
        <span className={`ml-2 font-light ${textSizeClasses[size]} ${isDark ? 'text-sage-300' : 'text-sage-600'}`}>
          Mind Polish
        </span>
      )}
    </div>
  );
};

export default MindPolishLogo;